import api from "./api";

export const getEmergencyInformation = async (id = "v8f0ijxniss7pucxy3alvasz") => {
    try {
        const response = await api.get(`/emergency-informations/${id}?populate=*`);
        return response.data.data;
    } catch (e) {
        console.error("Erreur lors du chargement des informations d'urgence:", e);
        throw e;
    }
};

export const updateEmergencyInformation = async (id = "v8f0ijxniss7pucxy3alvasz", data) => {
    try {
        const response = await api.put(`/emergency-informations/${id}`, { 
            data: data 
        });
        return response.data.data;
    } catch (e) {
        console.error("Erreur lors de la mise à jour des informations d'urgence:", e);
        throw e;
    }
};

export const addEmergencyContact = async (id = "v8f0ijxniss7pucxy3alvasz", contactData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const contacts = currentData.components_emergency_emergency_contacts || [];
        
        const updatedData = {
            components_emergency_emergency_contacts: [...contacts, contactData]
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de l'ajout du contact d'urgence:", e);
        throw e;
    }
};

export const removeEmergencyContact = async (id = "v8f0ijxniss7pucxy3alvasz", contactIndex) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const contacts = [...(currentData.components_emergency_emergency_contacts || [])];
        
        // Remove contact at the specified index
        contacts.splice(contactIndex, 1);
        
        const updatedData = {
            components_emergency_emergency_contacts: contacts
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la suppression du contact d'urgence:", e);
        throw e;
    }
};

export const addMedicalFacility = async (id = "v8f0ijxniss7pucxy3alvasz", facilityData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const facilities = currentData.components_emergency_medical_facilities || [];
        
        const updatedData = {
            components_emergency_medical_facilities: [...facilities, facilityData]
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de l'ajout de l'établissement médical:", e);
        throw e;
    }
};

export const removeMedicalFacility = async (id = "v8f0ijxniss7pucxy3alvasz", facilityIndex) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const facilities = [...(currentData.components_emergency_medical_facilities || [])];
        
        // Remove facility at the specified index
        facilities.splice(facilityIndex, 1);
        
        const updatedData = {
            components_emergency_medical_facilities: facilities
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la suppression de l'établissement médical:", e);
        throw e;
    }
};

export const addSafetyInfo = async (id = "v8f0ijxniss7pucxy3alvasz", safetyData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const safetyInfos = currentData.components_emergency_safety_infos || [];
        
        const updatedData = {
            components_emergency_safety_infos: [...safetyInfos, safetyData]
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de l'ajout de l'information de sécurité:", e);
        throw e;
    }
};

export const removeSafetyInfo = async (id = "v8f0ijxniss7pucxy3alvasz", safetyIndex) => {
    try {     
        // console.log(safetyIndex)
        const currentData = await getEmergencyInformation(id);
        const safetyInfos = [...(currentData.components_emergency_safety_infos || [])];
        
        // Remove safety info at the specified index
        safetyInfos.splice(safetyIndex, 1);
        
        const updatedData = {
            components_emergency_safety_infos: safetyInfos
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la suppression de l'information de sécurité:", e);
        throw e;
    }
};

export const updateEmergencyContact = async (id = "v8f0ijxniss7pucxy3alvasz", contactIndex, contactData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const contacts = [...(currentData.components_emergency_emergency_contacts || [])];
        
        // Update contact at the specified index
        contacts[contactIndex] = { ...contacts[contactIndex], ...contactData };
        
        const updatedData = {
            components_emergency_emergency_contacts: contacts
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la mise à jour du contact d'urgence:", e);
        throw e;
    }
};

export const updateMedicalFacility = async (id = "v8f0ijxniss7pucxy3alvasz", facilityIndex, facilityData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const facilities = [...(currentData.components_emergency_medical_facilities || [])];
        
        // Update facility at the specified index
        facilities[facilityIndex] = { ...facilities[facilityIndex], ...facilityData };
        
        const updatedData = {
            components_emergency_medical_facilities: facilities
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la mise à jour de l'établissement médical:", e);
        throw e;
    }
};

export const updateSafetyInfo = async (id = "v8f0ijxniss7pucxy3alvasz", safetyIndex, safetyData) => {
    try {
        const currentData = await getEmergencyInformation(id);
        const safetyInfos = [...(currentData.components_emergency_safety_infos || [])];
        
        // Update safety info at the specified index
        safetyInfos[safetyIndex] = { ...safetyInfos[safetyIndex], ...safetyData };
        
        const updatedData = {
            components_emergency_safety_infos: safetyInfos
        };
        
        return await updateEmergencyInformation(id, updatedData);
    } catch (e) {
        console.error("Erreur lors de la mise à jour de l'information de sécurité:", e);
        throw e;
    }
};